module.exports = __webpack_public_path__ + "img/fiverr logo copy 2.bf0ce5c1.png";